import React from "react";
import PowderRawMaterialCompositionTableRow from "./PowderRawMaterialCompositionRow";
import { PowderRawMaterialCompositionCard } from "./PowderRawMaterialCompositionRow";
import { usePowder } from "../redux/ReduxContext";

export type PowderRawMaterialCompositionSource = "allocated" | "stock";




export default function PowderRawMaterialComposition() {
    const { state, dispatch } = usePowder();

    const { materials } = state;
    const textClass = "text-primary-dark dark:text-primary-light";
    const [isCompact, setIsCompact] = React.useState<boolean>(() => {
        if (typeof window === "undefined") return false;
        return window.innerWidth < 1280;
    });

    React.useEffect(() => {
        if (typeof window === "undefined") return;

        const mql = window.matchMedia("(max-width: 1279px)");
        const apply = () => setIsCompact(mql.matches);
        apply();

        if (typeof mql.addEventListener === "function") {
            mql.addEventListener("change", apply);
            return () => mql.removeEventListener("change", apply);
        }

        mql.addListener(apply);
        return () => mql.removeListener(apply);
    }, []);

    if (materials.length === 0) {
        return null;
    }



    return (
        <div className="bg-white dark:bg-oi-dark-background p-4 mb-4">
            <div className={`mb-2 font-bold text-sm ${textClass}`}>Composition raw material</div>
            {isCompact ? (
                <div className="space-y-2">
                    {materials.map((material) => (
                        <PowderRawMaterialCompositionCard
                            key={material.lot + material.raw_mtrl + material.rvid}
                            material={material}
                        />
                    ))}
                    {materials.length === 0 ? (
                        <div className="px-1 py-4 text-center text-xs text-primary-dark dark:text-primary-light">No raw material added.</div>
                    ) : null}
                </div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full min-w-[1120px] table-fixed whitespace-nowrap border-separate border-spacing-y-2 text-left">
                        <thead>
                            <tr>
                                <th className={`px-1 h-[40px] text-xs font-semibold w-[180px] ${textClass}`}>Raw material</th>
                                <th className={`px-1 h-[40px] text-xs font-semibold w-[60px] ${textClass}`}>Lot</th>
                                <th className={`px-1 h-[40px] text-xs font-semibold w-[44px] ${textClass}`}>C%</th>
                                <th className={`px-1 h-[40px] text-xs font-semibold w-[70px] ${textClass}`}>O%</th>
                                <th className={`px-1 h-[40px] text-xs font-semibold w-[90px] ${textClass}`}>Ratio (%)</th>
                                <th className={`px-1 h-[40px] text-xs font-semibold w-[56px] ${textClass}`}>
                                    <button
                                        type="button"
                                        onClick={() => { }}
                                        className="hover:opacity-80"
                                        title="Add each row's Weight (g) to Allocate (g)"
                                    >
                                        Weight (g)
                                    </button>
                                </th>
                                {/* <th className={`px-1 h-[40px] text-xs font-semibold w-[20px] ${textClass}`}></th>
                                <th className={`px-1 h-[40px] text-xs font-semibold w-[54px] ${textClass}`}>Allocate (g)</th>
                                <th className={`px-1 h-[40px] text-xs font-semibold w-[120px] ${textClass}`}>Required date</th>
                                <th className={`px-1 h-[40px] text-xs font-semibold w-[88.5px] ${textClass}`}>Source</th>
                                <th className={`px-1 h-[40px] text-xs font-semibold w-[68px] ${textClass}`}>Allocated (g)</th> */}
                                <th className={`px-1 h-[40px] text-xs font-semibold w-[110px] ${textClass}`}>Stock (g)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {materials.map((material) => (

                                <PowderRawMaterialCompositionTableRow
                                    key={material.lot + material.raw_mtrl + material.rvid}
                                    material={material}
                                />
                            ))}
                            {materials.length === 0 ? (
                                <tr>
                                    <td colSpan={12} className="px-1 py-4 text-center text-xs text-primary-dark dark:text-primary-light">No raw material added.</td>
                                </tr>
                            ) : null}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
